import { defineStore } from 'pinia';

import { GatewayApiClient } from '@evidentid/gateway-api-client';
import { OperationStatus } from '@evidentid/vue-commons/store/OperationStatus';

import { ChatParty } from './models/ChatParty.model';
import { createOnlineChatMessage } from './utils/createOnlineChatMessage';
import { CHAT_ERROR_RESPONSE_MSG } from './utils/session-states/constants';
import { addMessageToSessionHistory } from './utils/session-states/sessionHistory';

export interface OnlineChatRequirements {
    gatewayClient: GatewayApiClient;
}

interface OnlineChatState {
    loadAgentResponse: OperationStatus;
}

function appOf(store: { $app: any }): OnlineChatRequirements {
    return store.$app;
}

export const useOnlineChatStore = defineStore('onlineChat', {
    state: (): OnlineChatState => ({
        loadAgentResponse: OperationStatus.uninitialized,
    }),
    actions: {
        setLoadingAgentResponse(status: OperationStatus) {
            this.loadAgentResponse = status;
        },
        async askAgent(payload: { rpName: string, question: any, sessionId: string, userEmail: string }) {
            const { question, rpName, sessionId, userEmail } = payload;
            this.setLoadingAgentResponse(OperationStatus.loading);
            try {
                const response = await appOf(this).gatewayClient.tprmUi()
                    .askChatAgent(rpName, question, sessionId, userEmail);
                const agentMessage = createOnlineChatMessage(response.answer.content, ChatParty.agent);
                addMessageToSessionHistory(agentMessage);
                this.setLoadingAgentResponse(OperationStatus.success);
            } catch (error) {
                console.error(error);
                addMessageToSessionHistory(createOnlineChatMessage(CHAT_ERROR_RESPONSE_MSG, ChatParty.agent));
                this.setLoadingAgentResponse(OperationStatus.error);
            }
        },
    },
});
